import {toggleMenu} from './menu';
import {toggleNominationBlock} from './nomination';

const $header = document.querySelector('.header') || false;

const scrollTo = (target) => {
  let targetPosition = 0;

  if (target) {
    const isNomination = target.classList.contains('js-nomination');
    if (isNomination) {
      const isNotOpen = !target.classList.contains('is-open');
      const $sectionInfo = document.querySelector('#section-info');
      targetPosition = target.offsetTop + $sectionInfo.offsetTop - 16;

      if (isNotOpen) {
        toggleNominationBlock(target);
      }
    } else {
      targetPosition = target.offsetTop - 16;
    }
  }

  const isMenuOpen = $header.classList.contains('header--menu-open');
  if (isMenuOpen) {
    toggleMenu();

    setTimeout(() => {
      window.scroll({
        top: targetPosition,
        left: 0,
        behavior: 'smooth',
      });
    }, 500);
  } else {
    window.scroll({
      top: targetPosition,
      left: 0,
      behavior: 'smooth',
    });
  }
};

const addScrollLinkListener = () => {
  document.addEventListener('click', (evt) => {
    const $target = evt.target;
    const $scrollLink = $target.closest('.js-scroll-link') || false;

    if ($scrollLink) {
      evt.preventDefault();
      const linkHref = $scrollLink.getAttribute('href');
      const isScrollTopLink = linkHref === '#scroll-top';

      if (isScrollTopLink) {
        scrollTo(false);
      } else {
        const $scrollTargetNode = linkHref && linkHref !== '#' ? document.querySelector(`${linkHref}`) || false : '';

        if ($scrollTargetNode) {
          scrollTo($scrollTargetNode);
        }
      }
    }
  });
};

export {addScrollLinkListener, scrollTo};
